import LoadPanel from 'devextreme-react/load-panel';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { formRegisterApi } from '../../api/formRegisterApi';
import appInfo from '../../app-info';
import { useScreenSizeClass } from '../../utils/media-query';
import FormRegisterPage from '../form-register/FormRegisterPage';
import styles from "./FormAttendancePage.module.css";
const FormAttendancePage = () => {
    const screenSizeClass = useScreenSizeClass();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);

    const params = location.pathname.replace('/form-register/', '').split('/');
    const dm_chiendich_id = params.length > 0 ? parseInt(params[0]) : 0;
    const ts_form_id = params.length > 1 ? parseInt(params[1]) : 0;

    useEffect(() => {
        const cachedData = localStorage.getItem(`${dm_chiendich_id}-${ts_form_id}`);
        if (cachedData) {
            const ts_form_register_result_id = parseInt(cachedData);
            if (ts_form_register_result_id > 0) {
                handeleAttendance({ ts_form_register_result_id })
            }
        } else {
            setIsLoading(false);
        }


    }, [dm_chiendich_id, ts_form_id]);

    const handeleAttendance = async ({ ts_form_register_result_id }) => {
        const res = await formRegisterApi.Attendance({
            id: ts_form_register_result_id,
            is_attendanced: true
        });
        if (res.is_success) {
            setIsSuccess(true);
            setIsLoading(false);
        } else {
            setIsSuccess(false);
            setIsLoading(false);
        }
    }
    return (
        <div className={styles.container}>
            <div className={styles.form_container}>
                <div className={styles.form + ' ' + screenSizeClass}>

                    {isLoading && <LoadPanel visible />}
                    {!isLoading && <>
                        {isSuccess && <AttendanceSuccess />}
                        {!isSuccess && <FormRegisterPage dmChienDichId={dm_chiendich_id} tsFormId={ts_form_id} isAttendance={true} />}
                    </>}

                </div>
            </div>
        </div>

    );
};
export const AttendanceSuccess = () => {
    return (
        <>
            <div className={styles.result}>
                <img className={styles.cover} src="../../../images/form-cover.png" />
                {/* <p className={styles.caption}>
                    Brighton College VietNam
                </p> */}

                <img className={styles.thank_img} src="../../../images/thank-you.png" />
                <div className={styles.content}>
                    <p className={styles.status_caption}>
                        Quý Phụ huynh đã đăng ký thành công. Hệ thống đã gửi email tới hòm thư Quý Phụ huynh đăng ký.
                    </p>
                    <p className={styles.question}>
                        Phòng tuyển sinh sẽ liên hệ lại với phụ huynh trong thời gian sớm nhất.
                    </p>
                </div>
            </div>
        </>
    );
}
export default FormAttendancePage;